import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const faqs = [
  {
    q: "Do you take insurance?",
    a: "Yes. We are in-network with Aetna, Cigna, United, Blue Cross Blue Shield (Empire) and Oxford. For out-of-network plans, we provide superbills for easy reimbursement.",
  },
  {
    q: "How quickly can I be seen?",
    a: "Most new patients are matched with a therapist within 2–4 business days. For urgent care, please call us directly.",
  },
  {
    q: "Do you offer telehealth?",
    a: "Yes. All of our clinicians offer secure HIPAA-compliant video sessions throughout New York State.",
  },
  {
    q: "What if it isn’t a good fit?",
    a: "We re-match you, at no cost. Therapy only works when the fit is right — we are committed to finding you the right person, not just any person.",
  },
  {
    q: "Is what I share confidential?",
    a: "Absolutely. Everything you share is protected under HIPAA. The only exceptions are mandatory reporting situations (imminent danger to self or others, abuse of a minor or elder).",
  },
  {
    q: "How long is each session?",
    a: "Individual sessions are 50 minutes. Couples and family sessions are 75 minutes. Initial consultations are 60 minutes.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-[#F4F1EA]" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="overline text-[#9F5C45] mb-6">07 — Common questions</p>
          <h2 className="font-serif font-light text-[#1C1917] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Before you <em className="italic text-[#3A5A40]">ask.</em>
          </h2>
        </div>

        <div className="md:col-span-7 md:col-start-6">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#E2DCD0]">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-serif text-xl md:text-2xl text-[#1C1917] py-6 hover:no-underline text-left"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#57534E] text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
